var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.no"),
                                        prop: "applyNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.applyNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "applyNo",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.applyNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.applyType"),
                                        prop: "applyType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "handle-input",
                                          staticStyle: { width: "100%" },
                                          attrs: { clearable: "" },
                                          model: {
                                            value: _vm.queryCondition.applyType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "applyType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.applyType",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t("common.all"),
                                              value: "",
                                            },
                                          }),
                                          _vm._l(
                                            _vm.applyTypeList,
                                            function (item, index) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label:
                                                    _vm._f("inputChoiceI18n")(
                                                      item
                                                    ),
                                                  value: item.code,
                                                },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.subject"),
                                        prop: "subject",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.subject,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "subject",
                                              $$v
                                            )
                                          },
                                          expression: "queryCondition.subject",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("apply.sourcing"),
                                        prop: "sourcingNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticClass: "handle-input",
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.sourcingNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "sourcingNo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.sourcingNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apply.shortlistedSuppliers"
                                                ),
                                                prop: "supplierCode",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  "suffix-icon":
                                                    "el-icon-search",
                                                },
                                                on: {
                                                  clear: _vm.clearSupplierName,
                                                },
                                                nativeOn: {
                                                  click: function ($event) {
                                                    _vm.showSelSupplierDialog = true
                                                    _vm.SupplierNameDialogReset = true
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .supplierCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "supplierCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.supplierCode",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apply.quotationType"
                                                ),
                                                prop: "quotationType",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "handle-input",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .quotationType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "quotationType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.quotationType",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        _vm.$t("common.all"),
                                                      value: "",
                                                    },
                                                  }),
                                                  _vm._l(
                                                    _vm.quotationTypeList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apply.quotationStatus"
                                                ),
                                                prop: "quotationStatus",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "handle-input",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .quotationStatus,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "quotationStatus",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.quotationStatus",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        _vm.$t("common.all"),
                                                      value: "",
                                                    },
                                                  }),
                                                  _vm._l(
                                                    _vm.quotationStatusList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "apply.sourcingStatus"
                                                ),
                                                prop: "sourcingStatus",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  table: "TT_SOURCING_HEAD",
                                                  field: "STATUS",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .sourcingStatus,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "sourcingStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.sourcingStatus",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("apply.status"),
                                                prop: "status",
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "handle-input",
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: { clearable: "" },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.status",
                                                  },
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        _vm.$t("common.all"),
                                                      value: "all",
                                                    },
                                                  }),
                                                  _vm._l(
                                                    _vm.statusList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label:
                                                            _vm._f(
                                                              "inputChoiceI18n"
                                                            )(item),
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("common.createBy"),
                                                prop: "buyerName",
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .buyerName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "buyerName",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.buyerName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "创建日期(从)",
                                                prop: "createDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .createDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "createDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.createDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "创建日期(至)",
                                                prop: "createEndDate",
                                              },
                                            },
                                            [
                                              _c("el-date-picker", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  "value-format": "yyyy-MM-dd",
                                                  type: "date",
                                                  placeholder:
                                                    _vm.$t("common.selDate"),
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .createEndDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "createEndDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.createEndDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.queryData(1)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.restQueryFormThis },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.ApplyCreateNew,
                      expression: "ApplyCreateNew",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addNewApply(-99999)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.addNew")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.lineApplyDelete,
                      expression: "lineApplyDelete",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "danger" },
                  on: { click: _vm.deleteQuotationApply },
                },
                [_vm._v(_vm._s(_vm.$t("common.del")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.lineApplyClose,
                      expression: "lineApplyClose",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.closeQuotationApply },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancellation")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "applyDataTable",
              staticClass: "table",
              attrs: {
                sortable: "",
                "max-height": "1750px",
                data: _vm.applyList,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  width: "50",
                  label: _vm.$t("common.select"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: {
                              disabled: scope.row.status == "3",
                              label: scope.row.ttQuotationApplyId,
                            },
                            nativeOn: {
                              change: function ($event) {
                                return _vm.getSelectRow(scope.row)
                              },
                            },
                            model: {
                              value: _vm.radioVal,
                              callback: function ($$v) {
                                _vm.radioVal = $$v
                              },
                              expression: "radioVal",
                            },
                          },
                          [_vm._v(" ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "applyNo",
                  label: _vm.$t("apply.no"),
                  "min-width": "100px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.openQuotationApplyDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.applyNo) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "applyTypeI18n",
                  label: _vm.$t("apply.applyType"),
                  "min-width": "70px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "subject",
                  label: _vm.$t("apply.subject"),
                  "min-width": "150px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "supplierNames",
                  label: _vm.$t("apply.shortlistedSuppliers"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "quotationTypeI18n",
                  label: _vm.$t("apply.quotationType"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "name",
                  label: _vm.$t("common.createBy"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "createDate",
                  label: _vm.$t("common.createDate"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "statusI18n",
                  label: _vm.$t("apply.status"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "roundNumber",
                  label: _vm.$t("apply.quotationRound"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "quotationStatusI18n",
                  label: _vm.$t("apply.quotationStatus"),
                  "min-width": "100px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  prop: "sourcingNo",
                  label: _vm.$t("apply.sourcing"),
                  "min-width": "130px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.sourcingList,
                        function (item, index) {
                          return _c(
                            "el-link",
                            {
                              key: index,
                              staticStyle: { display: "block" },
                              attrs: { type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openSoucingInfo(item.sourcingNo)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.sourcingNo))]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  align: "center",
                  sortable: "",
                  label: _vm.$t("apply.sourcingStatus"),
                  "min-width": "110px",
                  prop: "status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(
                        scope.row.sourcingList,
                        function (item, index) {
                          return _c(
                            "el-link",
                            {
                              key: index,
                              staticStyle: { display: "block" },
                              attrs: { type: "info" },
                            },
                            [_vm._v(_vm._s(item.status))]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": _vm.pageSizeChange,
                  "current-change": _vm.pageNumberChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showSelSupplierDialog,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showSelSupplierDialog = $event
            },
          },
        },
        [
          _vm.SupplierNameDialogReset
            ? _c("SelSupplier", {
                ref: "supplierSelRef",
                attrs: { multipleSelectionFlag: false },
                on: { subCallMethod: _vm.selectSupplierMethod },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }